// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trimmer_wrapper__LX\\+S9 {
  position: relative;

  display: flex;
  align-items: center;

  width: 100%;
  height: 52px;

  outline: none;
}

.trimmer_backgroundLine__aG8pS {
  pointer-events: none;

  position: absolute;
  left: 0;

  width: 100%;
  height: 4px;
  border-radius: 2px;
}

.trimmer_currentTimeIndicator__2b7Dd {
  pointer-events: none;

  position: absolute;
  z-index: 1;
  bottom: 0;

  width: 1px;
  height: 54px;

  background: white;

  transition: opacity 0.2s;
}

.trimmer_currentTimeIndicator__2b7Dd::before {
  content: '';

  position: absolute;
  top: -16px;
  transform: translateX(-48%);

  display: block;

  border-top: 18px solid white;
  border-right: 10px solid transparent;
  border-bottom: none;
  border-left: 10px solid transparent;
}

.trimmer_hoverIndicator__NYrjR {
  pointer-events: none;

  position: absolute;
  bottom: 0;

  width: 1px;
  height: 63px;

  opacity: 0;
  background: rgba(255, 255, 255, 0.5);

  transition: opacity 0.2s;
}

.trimmer_wrapper__LX\\+S9:hover .trimmer_hoverIndicator__NYrjR {
  opacity: 1;
}

@media (prefers-reduced-motion) {
  .trimmer_hoverIndicator__NYrjR {
    transition: none;
  }
}

.trimmer_trimArea__1Tksc {
  pointer-events: none;

  position: absolute;

  min-width: 22px;
  height: 100%;
  border: 2px solid var(--primaryColor);

  /* Background for .trimArea is created as a pseudo-element because its color
  is dynamic and we want to add opacity to it and we can't do something like
  \`background: rgba(var(--primaryColor), 0.2);\` with CSS just yet */
}

.trimmer_trimArea__1Tksc::after {
    content: '';

    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;

    opacity: 0.2;
    background: var(--primaryColor);
  }

.trimmer_label__L1xfa {
  position: absolute;
  top: -17px;
  font-size: 10px;
  transition: transform 0.2s;
}

.trimmer_label__L1xfa:nth-child(1) {
    left: -2px;
  }

.trimmer_label__L1xfa:nth-child(2) {
    right: -2px;
  }

.trimmer_trimArea__1Tksc.trimmer_narrow__0Wfqw .trimmer_label__L1xfa:nth-child(1) {
  transform: translateX(-100%);
}

.trimmer_trimArea__1Tksc.trimmer_narrow__0Wfqw .trimmer_label__L1xfa:nth-child(2) {
  transform: translateX(100%);
}

.trimmer_trimArea__1Tksc button {
  pointer-events: all;
  cursor: col-resize;

  position: absolute;
  z-index: 1;

  height: 100%;
  padding: 0;
  border: none;

  background: none;
  outline: none;
}

.trimmer_trimArea__1Tksc button svg {
    display: block;
  }

.trimmer_trimArea__1Tksc button:focus-visible svg {
    outline: 2px solid var(--primaryColor);
  }

.trimmer_trimArea__1Tksc button:nth-of-type(1) {
    left: -11px;
  }

.trimmer_trimArea__1Tksc button:nth-of-type(2) {
    right: -11px;
  }
`, "",{"version":3,"sources":["webpack://./src/components/trimmer/trimmer.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;;EAElB,aAAa;EACb,mBAAmB;;EAEnB,WAAW;EACX,YAAY;;EAEZ,aAAa;AACf;;AAEA;EACE,oBAAoB;;EAEpB,kBAAkB;EAClB,OAAO;;EAEP,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;;EAEpB,kBAAkB;EAClB,UAAU;EACV,SAAS;;EAET,UAAU;EACV,YAAY;;EAEZ,iBAAiB;;EAEjB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;;EAEX,kBAAkB;EAClB,UAAU;EACV,2BAA2B;;EAE3B,cAAc;;EAEd,4BAA4B;EAC5B,oCAAoC;EACpC,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;;EAEpB,kBAAkB;EAClB,SAAS;;EAET,UAAU;EACV,YAAY;;EAEZ,UAAU;EACV,oCAAoC;;EAEpC,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,oBAAoB;;EAEpB,kBAAkB;;EAElB,eAAe;EACf,YAAY;EACZ,qCAAqC;;EAErC;;mEAEiE;AAcnE;;AAbE;IACE,WAAW;;IAEX,kBAAkB;IAClB,MAAM;IACN,OAAO;;IAEP,WAAW;IACX,YAAY;;IAEZ,YAAY;IACZ,+BAA+B;EACjC;;AAGF;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,0BAA0B;AAS5B;;AAPE;IACE,UAAU;EACZ;;AAEA;IACE,WAAW;EACb;;AAGF;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;;EAElB,kBAAkB;EAClB,UAAU;;EAEV,YAAY;EACZ,UAAU;EACV,YAAY;;EAEZ,gBAAgB;EAChB,aAAa;AAiBf;;AAfE;IACE,cAAc;EAChB;;AAEA;IACE,sCAAsC;EACxC;;AAEA;IACE,WAAW;EACb;;AAEA;IACE,YAAY;EACd","sourcesContent":[".wrapper {\n  position: relative;\n\n  display: flex;\n  align-items: center;\n\n  width: 100%;\n  height: 52px;\n\n  outline: none;\n}\n\n.backgroundLine {\n  pointer-events: none;\n\n  position: absolute;\n  left: 0;\n\n  width: 100%;\n  height: 4px;\n  border-radius: 2px;\n}\n\n.currentTimeIndicator {\n  pointer-events: none;\n\n  position: absolute;\n  z-index: 1;\n  bottom: 0;\n\n  width: 1px;\n  height: 54px;\n\n  background: white;\n\n  transition: opacity 0.2s;\n}\n\n.currentTimeIndicator::before {\n  content: '';\n\n  position: absolute;\n  top: -16px;\n  transform: translateX(-48%);\n\n  display: block;\n\n  border-top: 18px solid white;\n  border-right: 10px solid transparent;\n  border-bottom: none;\n  border-left: 10px solid transparent;\n}\n\n.hoverIndicator {\n  pointer-events: none;\n\n  position: absolute;\n  bottom: 0;\n\n  width: 1px;\n  height: 63px;\n\n  opacity: 0;\n  background: rgba(255, 255, 255, 0.5);\n\n  transition: opacity 0.2s;\n}\n\n.wrapper:hover .hoverIndicator {\n  opacity: 1;\n}\n\n@media (prefers-reduced-motion) {\n  .hoverIndicator {\n    transition: none;\n  }\n}\n\n.trimArea {\n  pointer-events: none;\n\n  position: absolute;\n\n  min-width: 22px;\n  height: 100%;\n  border: 2px solid var(--primaryColor);\n\n  /* Background for .trimArea is created as a pseudo-element because its color\n  is dynamic and we want to add opacity to it and we can't do something like\n  `background: rgba(var(--primaryColor), 0.2);` with CSS just yet */\n  &::after {\n    content: '';\n\n    position: absolute;\n    top: 0;\n    left: 0;\n\n    width: 100%;\n    height: 100%;\n\n    opacity: 0.2;\n    background: var(--primaryColor);\n  }\n}\n\n.label {\n  position: absolute;\n  top: -17px;\n  font-size: 10px;\n  transition: transform 0.2s;\n\n  &:nth-child(1) {\n    left: -2px;\n  }\n\n  &:nth-child(2) {\n    right: -2px;\n  }\n}\n\n.trimArea.narrow .label:nth-child(1) {\n  transform: translateX(-100%);\n}\n\n.trimArea.narrow .label:nth-child(2) {\n  transform: translateX(100%);\n}\n\n.trimArea button {\n  pointer-events: all;\n  cursor: col-resize;\n\n  position: absolute;\n  z-index: 1;\n\n  height: 100%;\n  padding: 0;\n  border: none;\n\n  background: none;\n  outline: none;\n\n  & svg {\n    display: block;\n  }\n\n  &:focus-visible svg {\n    outline: 2px solid var(--primaryColor);\n  }\n\n  &:nth-of-type(1) {\n    left: -11px;\n  }\n\n  &:nth-of-type(2) {\n    right: -11px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `trimmer_wrapper__LX+S9`,
	"backgroundLine": `trimmer_backgroundLine__aG8pS`,
	"currentTimeIndicator": `trimmer_currentTimeIndicator__2b7Dd`,
	"hoverIndicator": `trimmer_hoverIndicator__NYrjR`,
	"trimArea": `trimmer_trimArea__1Tksc`,
	"label": `trimmer_label__L1xfa`,
	"narrow": `trimmer_narrow__0Wfqw`
};
module.exports = ___CSS_LOADER_EXPORT___;
